define('plugins/musicfavourite/ui/dialogs',['./dialogs/limited-dialog', 'exports'], function(limitedDialog, exports) {

    exports.initialise = function(notifier) {
        limitedDialog.initialise(notifier);
    };

    return exports;

});

